import styled from "styled-components";
import Button from "~/componentes/Button";
import { Colors } from "~/config/Colors";

export const Pages = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 1rem;
  justify-content: center;
  margin-top: 0.5rem;
  
  .Pagination_controls {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .pag-number {
      background: ${Colors.Color2};
      border-radius: 2rem;
      padding: 0.2rem 0em 0.2rem 0;
      margin: 0 0.5rem;
    }
  }

  .Pagination_p_pageSummary {
    background: ${Colors.Color1};
    border-radius: 1rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 2.25rem;
    padding: 0 1rem;

    color: ${Colors.Color1};
    margin-left: 0.5rem;
    min-width: ${(props) =>
    props.summarydigits > 2 ? `${props.summarydigits * 0.4 + 3.6}em` : "4.4em"};
    font-size: 0.9rem;

    ${(props) => props.mobile && "text-align: center;"}
  }
`;

export const PageButtonNumber = styled(Button)`
  position: relative;
  background: none;
  border: none;
  font-size: 0.9rem;
  padding: 0.1rem 0.7rem;
  margin-left: 0rem;

  ${(props) => {
    if (props?.ativo) {
      return `
        color: ${Colors.Color13};
      `;
    } else {
      return `
        color: ${Colors.Color13};
      `;
    }
  }}

  :hover {
    color: ${Colors.Color13};
  }

  ${(props) => {
    if (props?.ativo) {
      return `
        span {
          position: absolute;
          content: "";
          display: block;
          background: ${Colors.Color4};
          width: 100%;
          height: 100%;
          margin-left: -0.7rem;
          margin-top: -0.1rem;
          border-radius: 0.5rem;
          transition: 1s;
        }
      `;
    } else {
      return `
        span {
          position: absolute;
          display: none;
          content: "";
          width: 0;
          height: 0;
          transition: 1s;
        }
      `;
    }
  }}

  :hover span {
    display: block;
    background: ${Colors.Color4};
    width: 100%;
    height: 100%;
    margin-left: -0.7rem;
    margin-top: -0.1rem;
    border-radius: 0.5rem;
  }

  p {
    position: relative;
  }
`;

export const PageButtonIcon = styled(Button)`
  background: ${Colors.Color1};
  width: 1.3rem;
  height: 1.3rem;
  border-radius: 0.3rem;
  border: none;
  color: ${Colors.Color7};
  font-size: 0.8em !important;

  :hover {
    background: ${Colors.Color4};
    color: ${Colors.Color13};
  }
`;
